import React from 'react';
import { useLocation } from 'react-router-dom';
import { MdInfo, MdBugReport } from 'react-icons/md';
import { FaFileContract } from 'react-icons/fa';
import { SidebarItem, MenuAccordionItem } from '../SidebarComponents';

const TermsMenu = () => {
  const location = useLocation();
  
  // Check if current route is active
  const isActive = (path) => {
    return location.pathname.startsWith(path);
  };

  // Check if an accordion is active based on subroutes
  const isAccordionActive = (parentPath) => {
    return location.pathname.startsWith(parentPath);
  };

  return (
    <MenuAccordionItem
      icon={FaFileContract}
      label="Termos e Condições"
      isActive={isAccordionActive('/termos')}
      defaultIsOpen={isAccordionActive('/termos')}
    >
      <SidebarItem 
        icon={MdInfo} 
        label="Privacidade" 
        to="/termos/privacidade" 
        active={isActive('/termos/privacidade')} 
        isSubmenuItem
      />
      <SidebarItem 
        icon={MdBugReport} 
        label="Condições de Uso" 
        to="/termos/condicoes" 
        active={isActive('/termos/condicoes')} 
        isSubmenuItem
      />
    </MenuAccordionItem>
  );
};

export default TermsMenu;